import { api } from '@/api/client'

export type AdminUiTranslationCatalogItem = {
  group: string
  key: string
  values: Record<string, string>
  is_custom: boolean
}

export async function fetchAdminUiTranslationCatalog(params?: {
  group?: string
  search?: string
}): Promise<AdminUiTranslationCatalogItem[]> {
  const res = await api.get('/admin/admin-ui-translations', { params })
  return res.data.data ?? []
}

export async function fetchAdminUiTranslationGroups(): Promise<string[]> {
  const res = await api.get('/admin/admin-ui-translations/groups')
  return res.data.data ?? []
}

export async function fetchAdminUiDictionary(lang: string): Promise<Record<string, unknown>> {
  const res = await api.get('/admin/admin-ui-translations/dictionary', {
    params: { lang },
  })
  return (res.data.data?.messages ?? {}) as Record<string, unknown>
}

export async function upsertAdminUiTranslations(
  items: Array<{ locale: string; group: string; key: string; value: string }>,
) {
  const res = await api.put('/admin/admin-ui-translations', { items })
  return res.data.data as { updated: number }
}

export async function seedAdminUiTranslations(overwriteNonCustom = false) {
  const res = await api.post('/admin/admin-ui-translations/seed', {
    overwrite_non_custom: overwriteNonCustom,
  })
  return res.data.data as { inserted: number; skipped: number }
}
